module.exports = __webpack_public_path__ + "media/flipcoin.f6583503.mp3";